export function copyToClipboard(text) {
    var hiddenElementId = '__copyClipboard-input';
    var hiddenElement = document.getElementById(hiddenElementId);
    if (!hiddenElement) {
        hiddenElement = document.createElement('input');
        hiddenElement.id = hiddenElementId;
        hiddenElement.type = 'hidden';
        document.body.appendChild(hiddenElement);
    }
    hiddenElement.value = text;
    hiddenElement.type = 'text';
    hiddenElement.select();
    document.execCommand('copy');
    hiddenElement.type = 'hidden';
}
//# sourceMappingURL=copyToClipboard.js.map